









































import { pageFactory } from '@/main/pages/pageFactory';
import { PageMode } from '@/main/utils/pageMode';
import { loginFormService } from '@/main/services/';
import _ from 'lodash';
import { AUTH_LOGOUT, ERROR } from '@/main/store/actionTypes';

import { store } from './store';
import { NAME as name } from './constants';

export default pageFactory(name, store).extend({
	data() {
		return {
			passwordOld: null as string | null,
			passwordNew1: null as string | null,
			passwordNew2: null as string | null,
		};
	},
	computed: {
		label() {
			return this.LocalizeFormular('edtHeslo');
		},
		pageMode() {
			return PageMode.EDIT;
		},
	},
	methods: {
		async changePassword() {
			try {
				this.startLoading();
				const data = _.pick(this.$data, ['passwordOld', 'passwordNew1', 'passwordNew2']);
				
				const response = await loginFormService.changePassword(data);
				
				if (response.status === 200) {
					
					this.showNotification({
						title: this.Localize('DMS3_SuccessTitle'),
						message: this.LocalizeChyboveHlasky('Hotovo'),
						type: 'success',
					});
					
					await new Promise(resolve => setTimeout(resolve, 2000));

					await this.$store.dispatch(AUTH_LOGOUT);
					
					this.showNotification({
						title: '',
						message: this.LocalizeLocal('LoginAgain'),
						type: 'info',
						showClose: false,
					});
				}
			} catch (err) {
				if (err?.response?.status === 400) {
					this.showNotification({
						title: '',
						message: err?.response?.data?.message || this.LocalizeLocal('PasswordChangeError'),
						type: 'error',
						showClose: true,
					});
				} else {
					this.$store.dispatch(ERROR, { err });
				}
			} finally {
				this.endLoading();
			}
		},
	},
});
